<script>
  import { getContext, setContext } from "svelte";
  import { GridContainer, ListJustified } from "@ObamaFoundation/of-design-system";

  /** @type { string } */
  let className = "";
  export { className as class };
  export let data;

  const isContainerized = !!getContext("containerized");

  if (!isContainerized) {
    setContext("containerized", true);
  }
</script>

{#if isContainerized}
  <ListJustified {data} class={className} />
{:else}
  <GridContainer containerClass={className}>
    <ListJustified {data} />
  </GridContainer>
{/if}
